import { render, staticRenderFns } from "./TheMessageDropdown.vue?vue&type=template&id=2c28fe80&scoped=true"
import script from "./TheMessageDropdown.vue?vue&type=script&lang=js"
export * from "./TheMessageDropdown.vue?vue&type=script&lang=js"
import style0 from "./TheMessageDropdown.vue?vue&type=style&index=0&id=2c28fe80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28fe80",
  null
  
)

export default component.exports